export default __webpack_public_path__ + "static/media/cp_geo_bo.82720b03.svg";